import React from "react";
import { Link, Outlet } from "react-router-dom";

export const AuthLayout = () => {
  return (
    <div className="min-h-screen flex bg-white" data-testid="auth-layout">
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-blue-900">
        <img
          src="/images/yokolicious-storefront.jpg"
          alt="YOKOLICIOUS storefront at night"
          className="absolute inset-0 w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-blue-950/90 via-blue-900/30 to-transparent" />
        <div className="relative z-10 flex flex-col justify-end p-12 text-white">
          <Link to="/" data-testid="auth-hero-wordmark-link">
            <img src="/yokolicious-wordmark.png" alt="YOKOLICIOUS" className="w-72 mb-4 drop-shadow-lg" data-testid="auth-hero-wordmark" />
          </Link>
          <p className="text-blue-100 text-lg max-w-md">Operations Platform — secure onboarding, compliance and workforce management.</p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <Outlet />
      </div>
    </div>
  );
};
